import { useTranslation } from 'next-i18next/pages'
import { REFERRAL_AMOUNT_GIVE } from 'features/referral/Referral.constants'
import { ReferredProps } from 'features/referral/types'
import BlocksRenderer from 'components/blocks-renderer/BlocksRenderer'
import FaqWithDefaultDescription from 'components/faq-with-default-description/FaqWithDefaultDescription'
import { Header } from '@boltenergy-be/design-system'
import StartSimulationSection from 'sections/start-simulation/StartSimulationSection'
import InfluencerCarousel from 'features/referral/components/influencer-carousel/InfluencerCarousel'
import BoltOffering from 'sections/bolt-offering/BoltOffering'

const Referral = ({ activeAction, faqCategories, referralCode, videoTestimonials }: ReferredProps) => {
  // I18N
  const { t } = useTranslation('referral')

  // Constants
  const amountGive = activeAction?.reduction || REFERRAL_AMOUNT_GIVE
  const firstName = referralCode.referrer.firstName

  return (
    <main>
      <Header
        title={activeAction?.websiteHeroReceiver?.title || t('referral.hero.title', { firstName, amountGive })}
        shape="s5"
        color="accent-warm"
      >
        {activeAction?.websiteHeroReceiver?.description ? (
          <BlocksRenderer content={activeAction.websiteHeroReceiver.description} />
        ) : (
          <p>{t('referral.hero.paragraph', { firstName, amountGive })}</p>
        )}
      </Header>

      <StartSimulationSection fullWidth />

      {!!videoTestimonials?.length && <InfluencerCarousel withDescription testimonials={videoTestimonials} />}

      <BoltOffering title={t('referral.offering.title')} showMediaOnMobile={false} />

      {/*	FAQ */}
      <FaqWithDefaultDescription categories={faqCategories} title={t('referral:faq.title')} />
    </main>
  )
}

export default Referral
